<div class="loader" *ngIf="loaders.length > 0">
  <mat-spinner class="rfq-spinner"></mat-spinner>
</div>
<div style="padding-bottom:45px;">
  <app-bread-crumbs [navigationRoute]="currentRoute" [currentPageString]="purchaseTypeString"
    [docStatusCode]="docStatusCode" [clickHandler]="returnToPreviousPage"
    (buttonActionHandler)="onBreadCrumbButtonClick($event)" [isLocked]="rfsLocked" (openRoDialog) = "showRoDialog()" 
    [breadCrumbFlow]="breadCrumbFlow" [activePage]="activePage" [isLoading]="loaders.length > 0"></app-bread-crumbs>
</div>
<mat-sidenav-container  class="drawer-container" [hasBackdrop]="true" *ngIf="permissionData$| async as permissionData">
  <mat-sidenav #drawer class="drawer" mode="over" position="end" [autoFocus]="false" [(opened)]="openPeAssignmentList">
    <app-purchasing-executive-assignment-list [docNo]="form.documentNo||''" [peAssignmentListResponse]="peResponseObj"
      (closeSideNav)="closeSideNav($event)" [isLocked]="rfsLocked"></app-purchasing-executive-assignment-list>
  </mat-sidenav>
  <mat-sidenav-content>
    <div class="page-container">
      <app-global-banner></app-global-banner>
      <app-layout class="container--form">
        <ng-container app-layout-above-inner-container>
          <shared-alert [type]="alertType.Info" *ngIf="shouldShowPEView && showAssignmentBar">
            <p alert-content class="mb-0">The current workflow status will only be completed when all personnel involved clicks on the
              <b>“Ready”</b> button.
              Meanwhile, you can continue making edits on the current document by clicking on <b>“Unready”.</b></p>
          </shared-alert>

          <shared-alert [type]="alertType.Info" *ngIf="shouldShowPEView && showAssignmentBar">
            <p alert-content class="mb-0">Please tag the appropriate vendors to the corresponding items. To find out who is responsible for
              sourcing for the respective material subgroup in this document, please refer to the assignment
              list.</p>
            <button alert-button type="button" class="alert__button--text-only" (click)="(!rfsLocked) && drawer.toggle()" [disabled]="rfsLocked">Assignment list</button>
          </shared-alert>

          <shared-alert [type]="alertType.Info" *ngIf="isDisplayGenerateRFQ()">
              <p alert-content class="mb-0">Clicking <strong>Generate RFQ</strong> will download a consolidated PDF of all current RFQ documents from this MP document, and initiate the RFQ deadline countdown as specified in the Item / Vendor tab.</p>
              <button alert-button type="button" class="alert__button--text-only" (click)="onGenerateRFQ()">Generate RFQ</button>
          </shared-alert>
        </ng-container>
          <app-form-header class="formHeader" [formHeaderElementList]="formStatus"></app-form-header>
          <mat-tab-group class="pt-3" #formTabs dynamicHeight mat-stretch-tabs="false" mat-align-tabs="start"
            [(selectedIndex)]="selectedIndex" (selectedTabChange)="currentTab($event)">
            <mat-tab label="Basic Information" bodyClass="mt-3" >
              <app-general [isReadOnly]="isReadOnly() && !permissionData.ability.can('update',permissionData.formBasicInfo, 'all')"></app-general>
              <div class="form-inputs"></div>
  
              <app-button class="padBtn mar-r-10 budgetBtn" name="Next" type="flat-button" tabindex='0' (keypress)="nextTab()"
                (click)="nextTab()"></app-button>
            </mat-tab>
            <mat-tab label="Item / Vendor" bodyClass="mt-2">
              <ng-template matTabContent>
                <app-item-vendor [isReadOnly]="isReadOnly()" [isLocked]="rfsLocked" id='itemVendor' #itemVendor></app-item-vendor>
                <div class="budgetBtn">
                  <app-button class="padBtn mar-r-10" name="Previous" tabindex='0' (keypress)="prevTab()" (click)="prevTab()"></app-button>
  
                  <app-button class="padBtn mar-r-10" name="Next" type="flat-button" tabindex='0' (keypress)="nextTab()" (click)="nextTab()"></app-button>
                </div>
              </ng-template>
  
            </mat-tab>
            <mat-tab bodyClass="mt-2" *ngIf="isRfqOrCorporatecard" [disabled]="disabledItemVendorTagging" label="Item-Vendor Tagging">
              <ng-template mat-tab-label>
                <div [tp]="taggingDisabledHelperText" tpMaxWidth="400px" tpClassName="custom-tooltip" [tpInteractive]="true"
                  [tpIsEnabled]="disabledItemVendorTagging" [tpPlacement]="'bottom'">
                  Item-Vendor Tagging
                </div>
              </ng-template>
              <app-tagging-list [isReadOnly]="isReadOnly()" [isLocked]="rfsLocked">
              </app-tagging-list>
              <app-tagging-validation></app-tagging-validation>
              <div class="budgetBtn">
                <app-button class="padBtn mar-r-10" name="Previous" tabindex="0" (keypress)="prevTab()"
                  (click)="prevTab()"></app-button>
            
                <app-button class="padBtn mar-r-10" name="Next" type="flat-button" tabindex="0" (keypress)="nextTab()"
                  (click)="nextTab()"></app-button>
              </div>
            </mat-tab>
            <mat-tab bodyClass="mt-2" *ngIf="purchaseType === 'tender' || purchaseType === 'dc'" label="Add-on features">
              <app-add-on-feature [prevTab]="onNavigateToItemVendor" [isReadOnly]="isReadOnly() && !permissionData.ability.can('update',permissionData.formAor)"></app-add-on-feature>
              <div class="budgetBtn">
                <app-button class="padBtn mar-r-10" name="Previous" tabindex="0" (keypress)="prevTab()" (click)="prevTab()"></app-button>
  
              <app-button class="padBtn mar-r-10" name="Next" type="flat-button" tabindex="0" (keypress)="nextTab()" (click)="nextTab()"></app-button>
              </div>
            </mat-tab>
            <mat-tab label="Attachment" bodyClass="mt-2">
              <app-attachment #attachment [isReadOnly]="isReadOnly() && !permissionData.ability.can('update',permissionData.formVendorDoc)"  [isLocked]="rfsLocked" (attachmentLoaded)="initValidation($event)"></app-attachment>
              <div class="budgetBtn">
                <app-button class="padBtn mar-r-10 budgetBtn" name="Previous" tabindex="0" (keypress)="prevTab()" (click)="prevTab()"></app-button>
                <app-button class="padBtn mar-r-10" name="Next" type="flat-button" tabindex="0" (keypress)="nextTab()" (click)="nextTab()"></app-button>
              </div>
            </mat-tab>
            <mat-tab label="Current Workflow" bodyClass="mt-2">
              <app-current-workflow [MpNumber]="form.documentNo"
                [DraftType]="form.documentStatusId == 2 || form.documentStatusId == 3"
                [updatedDataSource]="this.updatedCurrentWorkflowHistory" [isGenerateWorkflowError]="this.isGenerateWorkflowError"></app-current-workflow>
              <app-button class="budgetBtn test" name="Previous" tabindex="0" (keypress)="prevTab()" (click)="prevTab()"></app-button>
              <app-button class="budgetBtn" name="Next" type="flat-button" tabindex="0" (keypress)="nextTab()" (click)="nextTab()"></app-button>
            </mat-tab>
            <mat-tab label="Reference" bodyClass="mt-3">
              <app-reference></app-reference>
              <app-button class="padBtn mar-r-10 budgetBtn" name="Previous" tabindex="0" (keypress)="prevTab()" (click)="prevTab()"></app-button>
              <app-button *ngIf="form.documentStatusId != 2 && form.documentStatusId != 3" class="budgetBtn" name="Next"
                type="flat-button" tabindex="0" (keypress)="nextTab()" (click)="nextTab()"></app-button>
            </mat-tab>
          </mat-tab-group>
      </app-layout>
    </div>
    <ng-template #taggingDisabledHelperText>
      <div class="custom-tooltip">
        <p>
          This tab is enabled only if your document needs to go through the Request for Sourcing workflow, which involves
          item and vendor tagging done by Purchasing Executives.
        </p>
      </div>
    </ng-template>
  </mat-sidenav-content>
</mat-sidenav-container>
